import { storageKey } from '../constants';

const setSelectedLocale = locale => {
  localStorage.setItem(storageKey, locale);
};

export default setSelectedLocale;
